module.exports = __webpack_public_path__ + "static/media/iphone15promax.8e8a21fa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/slider-banners/instagram-promo/iphone15promax.png
// module id = 2461
// module chunks = 7